(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("bluebird"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "bluebird"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("bluebird")) : factory(root["underscore"], root["bluebird"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__38__) {
return 